import React from "react";
import { connect } from "react-redux";
import { CallbackComponent } from "redux-oidc";
import userManager from "../Common/Utility/usermanager";
import { push } from "connected-react-router";

class CallbackPage extends React.Component {
    render() {
        return (
            <CallbackComponent
                userManager={userManager}
                successCallback={() => this.props.dispatch(push("/"))}
                errorCallback={error => {
                    this.props.dispatch(push("/"));
                    console.log(error);
                }}
            >
                <div>Redirecting...</div>
            </CallbackComponent>
        );
    }
}

export default connect()(CallbackPage);